import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthData, getSessinIdFromLS } from "../../../services/storage/LocalStorage";
import { appType } from "../../../utils/config/configHelpers";
import { setBotWaitLoader } from "../../../state/actions/loader";
import { DotsLoader } from "../../ui/Loader/dotsLoader";
import { fullBotScriptReset, loadBotScriptStyles, removeBotScript, removeBotStyles, scriptSrc } from "../../../utils/ChatbotScriptHelpers";


const FMConversationalBot = () => {
    const selectedConversation = useSelector((state) => state?.chats.selectedConversation || null);
    const selectedBotDetails = useSelector((state) => state.domain.selectedBotDetails);
    const botWaitLoader = useSelector((state) => state.loader.botWaitLoader);

    const userDetail = getAuthData();
    const userData = userDetail?.user || {};

    const prevBotIdRef = useRef(null);
    const hasSentParamsRef = useRef(false);
    const prevConversationIdRef = useRef(null);
    const dispatch = useDispatch();
    const sessionId = getSessinIdFromLS();

    const styleId = "chatbot-project-styles-assistantBot";
    const stylePath = "/scripts/chatwidget/assistantBotCss/css/main.7d6c5bdb.css";

    useEffect(() => {
        if (!selectedConversation?.conversationId) return;

        window.CurrentEnvironement = process.env.REACT_APP_ENV || 'development';

        const botId = selectedConversation.botId || selectedConversation.bot?.botId;
        const convId = selectedConversation.conversationId;

        if (!botId || !convId) return;

        const isChanged =
            prevBotIdRef.current !== botId ||
            prevConversationIdRef.current !== convId;

        // if (isChanged) {
            dispatch(setBotWaitLoader(true));
            performCleanupAndLoad();

            prevBotIdRef.current = botId;
            prevConversationIdRef.current = convId;
        // }
    }, [selectedConversation?.conversationId]);


    const performCleanupAndLoad = async () => {
        const response = await fullBotScriptReset(null, null, true);
        if (response === true) {
            setTimeout(() => {
                loadBotScript();
            }, 100);
            setTimeout(() => {
                loadBotScriptStyles(styleId, stylePath);
                loadBotScript();
            }, 300);
        }
    };

    const loadBotScript = () => {
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
        if (existingScript) {
            removeBotScript();
        }

        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        script.onload = () => {
            dispatch(setBotWaitLoader(false));
            waitForWidgetInit();
        };
        script.onerror = (e) => {
            console.error("Error loading the script: ", e);
        };
        document.body.appendChild(script);
    };

    const waitForWidgetInit = () => {
        const botRoot = document.getElementById("chat-bot-project-root");
        if (!botRoot) return;

        const maxAttempts = 10;
        let attempts = 0;

        const interval = setInterval(() => {
            const isReady = (
                typeof window.getParamsFromFrontmNewWebApp === "function" &&
                botRoot?.querySelector("*")
            );

            if (isReady) {
                clearInterval(interval);
                sendParamsToEmbeddedChatbot();
            } else if (++attempts >= maxAttempts) {
                clearInterval(interval);
                console.error("Widget still not ready after retries.");
            }
        }, 500);
    };

    const sendParamsToEmbeddedChatbot = (retryCount = 0) => {
        if (hasSentParamsRef.current && !selectedConversation?.conversationId) return;

        const maxRetries = 5;
        const params = {
            userEmail: userData?.emailAddress || "",
            sessionId: sessionId || userDetail?.auth?.sessionId,
            appType: appType,
            conversationId: selectedConversation?.conversationId || "",
            platform: "web",
            botId: selectedConversation?.bot?.botId || selectedConversation?.botId || selectedBotDetails?.botId,
            botName: selectedConversation?.bot?.name || selectedBotDetails?.botName || "",
            botLogoUrl: selectedConversation?.bot?.logoUrl || selectedBotDetails?.logoUrl || "",
            userId: userDetail?.user?.userId || "",
        };

        if (typeof window.getParamsFromFrontmNewWebApp === "function" && selectedConversation) {
            hasSentParamsRef.current = true;
            window.getParamsFromFrontmNewWebApp(params);
        } else if (retryCount < maxRetries) {
            // console.warn(`Waiting for bot to init (${retryCount + 1}/${maxRetries})...`);
            setTimeout(() => sendParamsToEmbeddedChatbot(retryCount + 1), 500);
        } else {
            // console.error("Bot script did not initialize in time for chatwidget.");
        }
    };


    return (
        <div style={{ width: "100%", height: "100%", background: "#fff", position: "relative" }}>
            {botWaitLoader && <DotsLoader />}
            <div id="chat-bot-project-root" style={{ width: "100%", height: "100%" ,display: botWaitLoader ? "none" : "block" }}></div>
        </div>
    );
};

export default FMConversationalBot;
